/* eslint-disable no-new */

import React from 'react';
import axios from 'axios';
import setUpAxios from '../helperFunctions/helperFunctions';

import Hovercard from './hovercard/hovercard';

declare var $: any;
declare const Popper: any;

interface HovercardContainerState {
  visible: boolean;
  targetEl: any;
}

export default class HovercardContainer extends React.Component<any, HovercardContainerState> {
  componentDidMount() {
    setUpAxios();
    $('body').hoverIntent(this.showHovercard, () => {}, '.hovercard-trigger');
  }

  constructor(props: any) {
    super(props);
    this.state = { visible: false, targetEl: null };
  }

  render() {
    if (this.state.visible) {
      return (
        <Hovercard
          user={{ ...this.state }}
          handleHideHovercard={this.handleHideHovercard}
          poppify={this.poppify}
        />
      );
    }

    return null;
  }

  showHovercard = (e: any) => {
    const hovercardEl = this.getHovercardElement(e.target);
    const urlRoot = '/company/users/hovercards';
    const userId = this.getUserId(hovercardEl);

    axios.get(`${urlRoot}/${userId}`).then((response) => {
      this.setState({
        ...response.data.user,
        targetEl: hovercardEl,
        visible: true,
      });
      this.listenForMouseOut();
    });
  }

  getHovercardElement = (targetEl: any) => {
    return $(targetEl).closest('.hovercard-trigger');
  }

  getUserId = (hovercardEl: any) => {
    return hovercardEl.data('hovercard-user-id');
  }

  listenForMouseOut = () => {
    $(document).mousemove(this.maybeHide);
  }

  maybeHide = (e: any) => {
    if (!this.shouldNotHide(e)) {
      this.handleHideHovercard();
    }
  }

  shouldNotHide = (e: any) => {
    return $(e.target).is('.hovercard-trigger')
    || $(e.target).parents().is('.hovercard-trigger')
    || $(e.target).is('.hovercard-container')
    || $(e.target).parents().is('.hovercard-container');
  }

  handleHideHovercard = () => {
    $(document).off('mousemove', null, this.maybeHide);
    this.setState({ visible: false });
  }

  poppify = () => {
    new Popper(this.state.targetEl, $('.hovercard-container'), {
      placement: 'top',
      onCreate: (data: any) => {
        $('.hovercard-container .arrow.outer').css('left', data.offsets.arrow.left - 2);
      },
      modifiers: {
        arrow: {
          element: '.arrow.inner',
        },
        offset: {
          offset: 100,
        },
      },
    });
  }
}
